import { reminderPreferenceSchema, type ReminderPreference } from '@wolhasudang/shared';

export const REMINDER_PREFERENCE_KEY = 'wolhasudang.reminder-preference.v1';
export const DEFAULT_REMINDER_PREFERENCE: ReminderPreference = {
  paydayDay: 'last', agreed: true, quietStartHour: 22, quietEndHour: 7, timeZone: 'Asia/Seoul',
};

export function readReminderPreference(raw: string | null): ReminderPreference {
  if (!raw) return { ...DEFAULT_REMINDER_PREFERENCE };
  try {
    const parsed = reminderPreferenceSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : { ...DEFAULT_REMINDER_PREFERENCE };
  } catch { return { ...DEFAULT_REMINDER_PREFERENCE }; }
}

export function writeReminderPreference(preference: ReminderPreference, storage: Pick<Storage, 'setItem'> = window.localStorage): void {
  storage.setItem(REMINDER_PREFERENCE_KEY, JSON.stringify(reminderPreferenceSchema.parse(preference)));
}
